// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: 'efb0ae7',
    builtAt: '2026-08-25T14:55:52.064Z',
} as const;
